import {useHistory} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {Alert} from "@mui/material";
import BigSelector, {BigSelectorItem} from "../../components/common/BigSelector/BigSelector";
import {useAdminApi, ADMIN_NAMESPACES_KEY} from "./api";

export function AdminNamespacesTab() {
    var api = useAdminApi();
    var history = useHistory();

    var {data: namespaces, isLoading, isError, error} = useQuery(
        [ADMIN_NAMESPACES_KEY],
        () => api.listNamespaces(),
        {staleTime: 30000}
    );

    if (isError) {
        console.error(error);
        return <BigSelector title="Namespaces" emptyMessage={<Alert severity="error">Failed to load namespaces</Alert>}/>;
    }

    var items: BigSelectorItem[] = (namespaces || []).map((ns) => ({
        id: ns.key,
        name: ns.key,
        subtitle: ns.name || "(no name)",
        icon: <i className="fas fa-layer-group"/>,
        onActivate: () => history.push(`/admin/namespaces/${ns.key}`),
    }));

    return (
        <BigSelector title="Namespaces" items={items} loading={isLoading} emptyMessage="No namespaces found"/>
    );
}
